<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-dynamic-config-center`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M34.345 4.081a2 2 0 011.732 1L46.423 23a2 2 0 010 2L36.077 42.919a2 2 0 01-1.732 1h-20.69a2 2 0 01-1.732-1L1.577 24.998a2 2 0 010-2L11.923 5.082a2 2 0 011.732-1h20.69zm-1.154 4H14.809L5.62 24l9.19 15.919h18.382l9.19-15.92-9.19-15.918zm-2.114 5.66a2 2 0 00-1.732-1h-10.69a2 2 0 00-1.732 1L11.577 23a2 2 0 000 2l5.346 9.258a2 2 0 001.732 1h10.69a2 2 0 001.732-1L36.423 25a2 2 0 000-2l-5.346-9.258zm-2.886 3h-8.382L15.62 24l4.19 7.258h8.382L32.38 24l-4.19-7.258zM27 24a3 3 0 10-6 0 3 3 0 006 0z"/></svg>
</template>
<script>

export default {
  name: 'IconDynamicConfigCenter',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
